import { POSTS } from "./constant";
import { InstagramPostsContainer, PostCard } from "./InstagramPosts.styles";
import Carousel from "react-multi-carousel";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1363 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1363, min: 1050 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 1050, min: 300 },
    items: 1,
  },
  smallMobile: {
    breakpoint: { max: 300, min: 0 },
    items: 1,
  },
};

const InstagramPosts = () => {
  return (
    <InstagramPostsContainer>
      <Carousel
        responsive={responsive}
        autoPlay={true}
        swipeable={true}
        draggable={true}
        showDots={true}
        infinite={true}
        partialVisible={false}
      >
        {POSTS.map((post) => {
          return post.render;
        })}
      </Carousel>
    </InstagramPostsContainer>
  );
};

export default InstagramPosts;
